import React, { useEffect } from 'react'
import ServiceSupportTile from './HeaderContainer_New/ServiceSupportTile';
import ShoppingListsTile from './HeaderContainer_New/ShoppingListsTile';
import MyAccountTile from './HeaderContainer_New/MyAccountTile';
import QuickOrderTile from './HeaderContainer_New/QuickOrderTile';
import MyCartTile from './HeaderContainer_New/MyCartTile';
import CatalogExportTile from './HeaderContainer_New/CatalogExportTile';
import RedeemVoucherTile from './HeaderContainer_New/RedeemVoucherTile';
import useStateRef from 'react-usestateref';

function CommonTiles(props) {
    // const stringArray = ["MyAccountTile", "ServiceSupportTile", "ShoppingListsTile", "QuickOrderTile", "MyCartTile"];
    const[menuData, setMenuData, menuDataRef] = useStateRef([])
    const[menuItems, setMenuItems, menuItemsRef] = useStateRef([])
    const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef("")
    
    // const stringArrays = menuItems.map(item => item?.ContentRuleZone?.[0]?.attributes?.topMenuName ?? "");
  
        useEffect(()=>{
          
          setScreenWidth(screen.width)
          var menuTileList = [];
          var menuTileAttrList = [];

          if(screenWidthRef.current > 991) {
            const desktopAttributes = props.menuTile.map(item => item.ContentRuleZone && item.ContentRuleZone[0] && item.ContentRuleZone[0].attributes && item.ContentRuleZone[0].attributes.menuViewResolution === "desktop"  && !menuTileList.includes(item.ContentRuleZone[0].attributes.topMenuName)  &&  menuTileList.push(item.ContentRuleZone[0].attributes.topMenuName) && menuTileAttrList.push(item));
          } else {
            const mobileAttributes = props.menuTile.map(item => item.ContentRuleZone && item.ContentRuleZone[0] && item.ContentRuleZone[0].attributes && item.ContentRuleZone[0].attributes.menuViewResolution === "mobile" && !menuTileList.includes(item.ContentRuleZone[0].attributes.topMenuName)  && menuTileList.push(item.ContentRuleZone[0].attributes.topMenuName) && menuTileAttrList.push(item));
          }
          setMenuData(menuTileList)
          setMenuItems(menuTileAttrList)
        },[])

    const componentMap = { 
    MyAccountTile: MyAccountTile,
      ServiceSupportTile: ServiceSupportTile,
      ShoppingListsTile: ShoppingListsTile,
      QuickOrderTile:QuickOrderTile,
      MyCartTile:MyCartTile,
      CatalogExportTile:CatalogExportTile,
      RedeemVoucherTile:RedeemVoucherTile
    };
  return (
    <> 
      {menuDataRef.current.map((componentName, index) => {
            const Component = componentMap[componentName];
            
            const data = menuItemsRef.current.filter((menu)=> menu?.ContentRuleZone?.[0]?.attributes?.topMenuName===componentName);
            return Component && <Component key={index} {...props} data={data} />;
        })}
      </>
  )
}

export default CommonTiles

